import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import DaModal from './DaModal';
const Modals = (_param)=>{
    var { modals =[]  } = _param, rest = _object_without_properties(_param, [
        "modals"
    ]);
    if (modals.length === 0) {
        return null;
    }
    const renderedModals = modals === null || modals === void 0 ? void 0 : modals.map((modal, index)=>/*#__PURE__*/ React.createElement(DaModal, _extends({
            modal: modal
        }, rest, {
            key: index
        })));
    return renderedModals ? // Typescript doesn't like us returning arrays for a React.FC return type despite it being totally fine.
    // Context here: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18912
    /*#__PURE__*/ React.createElement(React.Fragment, null, renderedModals === null || renderedModals === void 0 ? void 0 : renderedModals.map((modal, index)=>/*#__PURE__*/ React.createElement(React.Fragment, {
            key: index
        }, modal))) : null;
};
Modals.displayName = 'Modals';
export default Modals;
